import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import BillBoard from '../../advertisements/BillBoard';
import LargeRectangle from '../../advertisements/LargeRectangle';
import { TitleHeading } from '../../UIElements/headings/TitleHeading';
import { BasicCards } from '../cards/BasicCards';
import listingService from '../service/listingService';
import { useViewportBillBoard } from '../../utility/useViewport';
import Loader from '../../utility/Loader';
import styles from '../cards/card.module.css'

const RecentListings = (props) => {

    const coords = useSelector(state => state.current_coords);
    const [listings, setListings] = useState([]);
    const viewedListings = useSelector(state => state.viewedListings);
    const isBillboard = useViewportBillBoard();
    const [offsets, setOffsets] = useState(0);
        const [hasMoreData, setHasMoreData] = useState(true);

    const heading = {
        business: 'Business Listings',
        event: 'Event Listings',
        job: 'Job Listings',
        news: 'Aajubaaju My Pages',
        reviews: 'Aajubaaju My Reviews',
        article: 'Aajubaaju My Videos',
        photos: 'Aajubaaju My Photos',
        album: 'Aajubaaju My Album',
    }

    const getListingDetails = (listing) => {
        const searchCriteria = listingService.getListingSettings(listing, coords);
        const businessName = listing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
        const listingPath = encodeURI(`/l/${businessName}/${listing.hpId}`);
        props.history.push(listingPath, {
            place: null,
            isViewed: viewedListings.includes(listing.hpId),
            searchCriteria: searchCriteria,
        });
    }

    const handleSeeMore = async () => {
        try {
            const newOffset = offsets + 1;
            listingService.getRecentListingsByType(coords, props.listingType, newOffset).then(data => {
                if (data.length === 0) {
                    setHasMoreData(false); // No more data to fetch
                } else {
                    setListings(prevListings => [...prevListings, ...data]);
                    setOffsets(newOffset);
                }
            }).catch(() => {
                Loader.stopSpinner();
            });
        } catch (error) {
            console.error("Error fetching more videos:", error);
        }
    };

    useEffect(() => {
        if (!coords.latitude)
            return;

        listingService.getRecentListingsByType(coords, props.listingType).then(data => {
            //.sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
            setListings(data);
        })
    }, [coords])

    return (
        listings.length > 0 ?
            <div>
                <TitleHeading text={`Recently Added ${heading[props.listingType]}`} />
                {/* <div className="row"> */}
                    <BasicCards listings={listings}
                        showContent={getListingDetails}
                        viewedContentIds={viewedListings}
                        type={props.listingType} />
                    {hasMoreData ? (
                        <p className={styles.read_more_button} onClick={handleSeeMore} style={{ textAlign: 'center'}}>See More...</p>
                    ) : (
                        <p className={styles.read_more_button} style={{ textAlign: 'center' }}>No more to show</p>
                    )}
                    <br></br><br></br>
                {/* </div> */}
                <div className='row'>
                    {isBillboard ? <LargeRectangle spot={props.bannerAdSpot} />
                        : <BillBoard spot={props.bannerAdSpot} />}
                </div>
            </div> : <></>
    )
}

export default RecentListings;